import { Stack, Text, Button, Icon, HStack } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../../../../shared/stores/RootStore";
import { useMemo } from "react";
import { CheckIcon } from "../../../../../shared/views/icons";

const HlaStatsBase: React.FC = () => {
  const { projectStore, hlaStore, filterStore } = useStores();

  const [nVerifiedWays, nWays] = useMemo(() => {
    const allWays = filterStore.filteredHlaWays.length;
    var verifiedCounter = 0;

    for (const way of filterStore.filteredHlaWays) {
      if (way.verified) {
        verifiedCounter++;
      }
    }

    return [verifiedCounter, allWays];
  }, [filterStore.filteredHlaWays]);

  if (nWays === 0) return null;

  const project = projectStore.getSelected();

  return (
    <Stack px={4}>
      <Text
        fontSize="xs"
        textTransform={"uppercase"}
        fontWeight={"semibold"}
        color={"gray.700"}
        pt={2}
      >
        High-level assessments
      </Text>
      <HStack fontSize="sm">
        <Icon
          as={CheckIcon}
          color={nVerifiedWays === nWays ? "primary.600" : "gray.300"}
        />
        <Text>
          {nVerifiedWays} out of {nWays} assessments verified
        </Text>
      </HStack>
      {nVerifiedWays !== nWays && (
        <Button
          size="sm"
          disabled={!project?.permissions?.canCodeHla}
          colorPalette={"primary"}
          onClick={() => {
            const firstUnverified = filterStore.filteredHlaWays.find(
              (w) => !w.verified,
            )!;
            hlaStore.select(firstUnverified.id);
          }}
        >
          Start coding
        </Button>
      )}
    </Stack>
  );
};

export const HlaStats = observer(HlaStatsBase);
